import React, { Component } from "react";
import { connect } from 'react-redux';
import AppContent from './app'
import { useParams } from "react-router-dom";
import { NavigationHeader } from "../../../_metronic/layout/components/navigationheader/NavigationHeader";
import { getInitialRoute } from "../../../../../../../utils";

const APPS=(props)=>{
    const param = useParams();
    return <AP param={param} {...props}/>;
}


class AP extends Component {
    state = {
        item: null
    }
    componentDidMount() {
        const { history, apps, match, param } = this.props;
        const { wallId } = match.params;
 
        if (apps && apps.apps && apps.apps.length > 0) {
            const data = apps.apps.filter((item) => item.id == param.appID)
            if (data && data[0]) {
                this.setState({ item: data[0] })
            }
        }
        else{ 
            setTimeout(() => {
                history(`/studio/${localStorage.getItem('wallId')}/apps/${param.contentMixId}/${param.positionID}`)
            }, 1000);
        }
    }

    render() {
        const { match } = this.props;
        const { item } = this.state;

        return item && Object.keys(item) && Object.keys(item).length && <>
            {/* <NavigationHeader name={item.name} backToNavigation={`/studio/${match.params.wallId}`} /> */}
            <AppContent {...item} {...this.props} />
        </>;
    }
}

const mapStateToProps = state => {
    return {
        apps: state.apps
    }
}



export default connect(mapStateToProps)(APPS);